import { TableColumn } from '../../models';
import { TextCellComponent, TextCellProps } from './text.component';

export class TextColumn<I> extends TableColumn<I, TextCellProps> {
  readonly component = TextCellComponent;
}
